import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth0 } from "../Auth";
import { config } from "../config";
import QueryString from "query-string";
import {hasStoredAuthLoginErrorMessage} from "../utils/authLoginError";

const PrivateRoute = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { loading, isAuthenticated, auth0Disabled, loginWithRedirect } = useAuth0();
  
  useEffect(() => {
    if (hasStoredAuthLoginErrorMessage()) {
      return;
    }

    const query = QueryString.parse(location.search);
    let tokenExtracted = false;

    if (query.reportId) {
      localStorage.setItem("reportId", query.reportId.toString());
    }

    if (query.accessToken) {
      sessionStorage.setItem("suiteManagerToken", query.accessToken.toString());
      tokenExtracted = true;
    }

    if (query.refreshToken) {
      sessionStorage.setItem("suiteManagerRefresh", query.refreshToken.toString());
      tokenExtracted = true;
    }

    if (query.data) {
      try {
        const suiteManagerData = JSON.parse(window.atob(query.data.toString()));
        if (suiteManagerData?.accessToken) {
          sessionStorage.setItem("suiteManagerToken", suiteManagerData.accessToken.toString());
        }
        if (suiteManagerData?.refreshToken) {
          sessionStorage.setItem("suiteManagerRefresh", suiteManagerData.refreshToken.toString());
        }
        tokenExtracted = true;
      } catch (e) {
        console.error('Invalid Suite Manager data payload');
      }
    }

    if (tokenExtracted) {
      window.history.replaceState({}, document.title, window.location.pathname);
    }
    
    if (!loading && !isAuthenticated) {
      if (auth0Disabled) {
        navigate('/');
      } else {
        loginWithRedirect({
          appState: { targetUrl: config.redirectUri }
        });
      }
    }
  }, [auth0Disabled, loading, isAuthenticated, loginWithRedirect, location.search, navigate]);
  
  if (loading) return null;
  
  return isAuthenticated ? <>{children}</> : null;
};

export default PrivateRoute;
